import { render, staticRenderFns } from "./GFDashboard.vue?vue&type=template&id=0501d924&scoped=true"
import script from "./GFDashboard.vue?vue&type=script&lang=js"
export * from "./GFDashboard.vue?vue&type=script&lang=js"
import style0 from "./GFDashboard.vue?vue&type=style&index=0&id=0501d924&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0501d924",
  null
  
)

export default component.exports